import React from "react";
import {InfoAboutDoctorProps} from "./types";
import Avatar from "@mui/material/Avatar";
import {Stack, Typography} from "@mui/material";

const InfoAboutDoctor: React.FC<InfoAboutDoctorProps> = ({doctor}) => {
    // Функция для проверки валидности отчества
    const isValidMiddleName = (middleName: string | null | undefined): boolean => {
        if (!middleName || middleName.trim().length === 0 || middleName === ".") {
            return false;
        }
        // Проверяем, что длина больше 1 и есть хотя бы одна буква
        return middleName.length > 1 && /[a-zA-Zа-яА-Я]/.test(middleName);
    };

    // Разбиваем полное имя на части
    const nameParts = doctor.fullName.split(" ").filter(part => part.trim() !== "");

    // Определяем компоненты имени
    const lastName = nameParts[0] || "";
    const firstName = nameParts[1] || "";
    const middleName = nameParts[2] || null;

    // Определяем формат отображения
    const shouldDisplayShort = isValidMiddleName(middleName);

    return (
        <Stack className={'info-about-doctor'} direction="row" spacing={3} alignItems="center">
            <Avatar className={'doctor-avatar'} variant="square" src={doctor.photo!} alt={"avatar"}/>
            <div>
                <Stack direction="row" spacing={1}>
                    <Typography variant="h5">
                        {lastName}
                    </Typography>
                    {shouldDisplayShort ? (
                        <>
                            <Typography variant="h5" component="span">
                                {firstName.charAt(0)}.
                            </Typography>
                            <Typography variant="h5" component="span">
                                {middleName!.charAt(0)}.
                            </Typography>
                        </>
                    ) : (
                        <Typography variant="h5" component="span">
                            {firstName}
                        </Typography>
                    )}

                </Stack>
                <Typography color={"text.secondary"} fontSize={14}>
                    категория: {doctor.category}
                </Typography>
                <Typography className={"specialty-text"} color={"text.secondary"} fontSize={14}>
                    специальность: {doctor.specialtyName}
                </Typography>
                <Stack>
                    <Typography sx={{fontWeight: "bold"}} color="text.secondary">
                        {doctor.misname}
                    </Typography>
                    <Typography fontSize={12} color="text.secondary">
                        {doctor.misaddress}
                    </Typography>
                </Stack>
            </div>
        </Stack>
    )
}

export default InfoAboutDoctor;